/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import {
  CollectionsIcon,
  colors,
  WarningIcon
} from "@dotnet/telematics-design-system";

import { selectableImageType } from "../..";
import Button from "../../../../../../components/Button/Button";
import { useStyles } from "../../styles";

interface IImageDropzoneContentProps {
  onButtonClick: () => void;
  selectedImage: selectableImageType | null;
  disabled?: boolean;
}

const ImageDropzoneContent = ({
  onButtonClick,
  selectedImage,
  disabled
}: IImageDropzoneContentProps) => {
  const { t } = useTranslation();

  const { noImageWarning } = useStyles();

  return (
    <>
      <div css={css([noImageWarning])}>
        {!selectedImage && (
          <WarningIcon
            data-testid="alert-warning-icon"
            color={disabled ? colors.textDisabled : colors.orange600}
          />
        )}

        {selectedImage && (
          <CollectionsIcon
            data-testid="image-collections-icon"
            style={{
              color: disabled ? colors.textDisabled : colors.textPlaceholder
            }}
          />
        )}
        <Typography
          variant="body2Medium"
          sx={{
            color: disabled ? colors.textDisabled : "unset"
          }}
        >
          {selectedImage?.imageName || t("Dropzone##no image")}
        </Typography>
      </div>

      <Button
        size="small"
        variant="textOnly"
        color="primarySubtle"
        onClick={onButtonClick}
        disabled={disabled}
        data-testid="dropzone-select-image-button"
      >
        {t("Button##select image")}
      </Button>
    </>
  );
};

export default ImageDropzoneContent;
